import { render, staticRenderFns } from "./FeLabel.vue?vue&type=template&id=aa9e25a0&scoped=true&"
import script from "./FeLabel.vue?vue&type=script&lang=js&"
export * from "./FeLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9e25a0",
  null
  
)

export default component.exports